import styled from 'styled-components';

import { Layout as DefaultLayout } from '@components/formStyles';
import DefaultLandingImage from '@assets/images/default-hotel-landing.png';
export const Layout = styled(DefaultLayout)`
  width: 100%;
  min-height: 500px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    min-height: auto;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column-reverse;
  }
`;

export const ContainerItem = styled.div<{ marginTop?: number }>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ marginTop = 0 }) => marginTop + 'px'};

  & h3 {
    margin-bottom: 27px;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      margin-bottom: 15px;
    }
  }
`;

export const ContentContainer = styled.div`
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 15px;
  }
`;

export const BannerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  & > div {
    max-width: 100%;
    width: 100%;
    height: 100%;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 20px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
`;

export const CampaignPromotionsWrapper = styled.div`
  .header {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: normal;
    color: ${({ theme }) => theme.palette.darkGrey};
  }
`;

export const Container = styled.div`
  & div:first-child {
    .default {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(3, 400px);
      height: 310px;
    }
  }
`;

export const Banner = styled.div<{ url?: string }>`
  background-image: url(${({ url }) => url ?? DefaultLandingImage.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding-left: 120px;
  padding-right: 120px;
  padding-top: 77px;
  height: 396px;
  position: relative;
  width: 100%;
`;

export const Element = styled.div`
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.6);
  height: 118px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 36px;
  font-weight: bold;
  position: relative;
  margin-left: 15px;
  color: ${({ theme }) => theme.palette.white};
  &:before {
    content: '';
    position: absolute;
    width: 6px;
    height: 27px;
    left: -15px;
    top: 16px;
    border-radius: 3px;
    background-color: ${({ theme }) => theme.palette.coral};
  }
`;
